module.exports = __webpack_public_path__ + "static/media/cricket.b9e94792.svg";